import React, { useEffect } from "react";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";

import Layout from "../../components/Layout";
import HeroZmtSection from "../../components/partials/zmt-page/hero-zmt-section.en";
import WhatIsZmt from "../../components/partials/zmt-page/what-is-zmt.en";
import { FullBanner as SubscribeToNewsletter } from "../../components/SubscribeBanner";
import UpcomingProjects from "../../components/partials/zmt-page/upcoming-projects.en";
import PartOfZipmex from "../../components/partials/zmt-page/part-of-zipmex.en";
import WelcomeToZipCrew from "../../components/partials/zmt-page/welcome-to-zipcrew.en";
import HowCanIGetZmts from "../../components/partials/zmt-page/how-can-i-get-zmts.en";
import TokenVestingSections from "../../components/partials/zmt-page/token-vesting-sections.en";
import ZmtRoadmap from "../../components/partials/zmt-page/zmt-roadmap.en";
import BenefitWithZMT from "../../components/partials/zmt-page/benefit-with-zmt.en";
import WithI18next from "../../components/WithI18next";
import SideContentTemplate from "../../components/ContentComponents/SideContentTemplate";

import { formatAcfPartial } from "../../utils";

import "../../components/partials/zmt-page/zmt.scss";

const ZmtPage = ({ data, pageContext, t, lang, location }) => {
  // FIXME: a quick fix for scrolling issue due to gasp animation(?)
  useEffect(() => {
    const url = location.href;
    if (url.indexOf("#") > 0) {
      document.getElementById("welcome-to-zipcrew").scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <Layout title={t("zmt.seo.title")} description={t("zmt.seo.description")}>
      <Helmet>
        <body className="zmt" />
      </Helmet>

      {/* TODO: use Hero/whatIsZmt content form WP */}
      <HeroZmtSection
      // content={data.heroContent}
      />

      <WhatIsZmt
        lang={lang}
        // content={data.whatIsZMTContent}
      />

      <BenefitWithZMT country={pageContext.wpGlobalConfig} />

      <HowCanIGetZmts />

      <WelcomeToZipCrew
        lang={lang}
        coinInterestRates={data.coinInterestRates}
      />

      <PartOfZipmex />

      <TokenVestingSections />

      <ZmtRoadmap />

      <UpcomingProjects />

      <SubscribeToNewsletter />

      {data.investContent && (
        <SideContentTemplate
          {...formatAcfPartial(data.investContent)}
          backgroundColor="blue"
          signupBtnClassNames="button-secondary button-rounded"
          isContentReversed={true}
        />
      )}
    </Layout>
  );
};

export default WithI18next()(ZmtPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    investContent: allWpPartialItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfPartials: { pPartialId: { eq: "cta-zmt-invest-anywhere-anytime" } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          acfPartials {
            pHeading
            pCssClasses
            pContent
            pIcon {
              localFile {
                publicURL
              }
            }
            pButtonText
            pButtonUrl
          }
        }
      }
    }

    coinInterestRates: allWpCoinInterestRatesItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { eq: ".all" } }
        language: { locale: { eq: "en_US" } }
      }
      sort: { order: ASC, fields: date }
    ) {
      nodes {
        acfCoinInterestRates {
          cirCoinCode
          cirZiplockRate
          zipupInterateRateV2 {
            vip0 {
              rate
            }
            vip1 {
              rate
            }
            vip2 {
              rate
            }
            vip3 {
              rate
            }
            vip4 {
              rate
            }
          }
        }
      }
    }
  }
`;
